<template>
    <div class="inner-box">
        <h2 class="title">{{title}}</h2>
        <div style="height:55px;"></div>
        <table class="visit-info-table">
            <tr>
                <th style="width:80px;">제목</th>
                <td><input class="input" v-model="form.subject" ref= "subject" placeholder="제목을 입력해 주세요." style="width:100%;" ></td>
            </tr>
            <tr v-if="updateMode">
                <th>등록일</th>
                <td>{{form.regDtm}}</td>
            </tr>

            <tr>
                <th>내용</th>
                <td><vue-editor v-model="form.content" ref="editor" :editor-toolbar="customToolbar" /></td>
            </tr>
            <tr>
                <th>첨부</th>
                <td>
                    <input type="file" ref="addFile" id="files" @change="selectFiles()" multiple hidden>
                    <button class="clickAddFileBtn" @click="clickAddFileBtn()">파일첨부</button>
                    <FileDisplay v-for="item in fileList" :file="item" @childs-event="deleteFile"></FileDisplay>
                  <div class="fileList" v-for="file in form.files" :key="file.id" @click="downloadFile(file.downloadUrl)"><span>{{file.originalName}}</span><span class="deleteBtn" @click='deleteFile'>삭제</span></div>
                </td>
            </tr>
        </table>
        <div class="btn">
            <button @click="savePost()">저장</button>&nbsp;
            <button @click="cancel()">취소</button>
        </div>
    </div>
</template>

<script>
    import { VueEditor } from "vue2-editor";
    import FileDisplay from '@/components/board/FileDisplay.vue';
    import $ from 'jquery'

    export default {
        name: 'BoardCreate',
        components: { VueEditor, FileDisplay },
        updateMode: null,
        props: {
            contentId: {
                type: String,
                required: false
            },
        },
        data() {
            return {
                title: "",
                category: "",
                updateObject: null,
                updateMode: false,
                customToolbar: [
                    [{ font: [] }],
                    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                    ["bold", "italic", "underline", "strike"],
                    [
                        { align: "" },
                        { align: "center" },
                        { align: "right" },
                        { align: "justify" }
                    ],
                    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    [{ color: [] }, { background: [] }],
                    ["link", "image", "video"],
                ],
                fileList: [],
                authority: '',
                form: {
                    id: '',
                    subject: '',
                    writer: null,
                    writer_id: '',
                    content: '',
                    comp_cd: '',
                    category: '',
                    viewCnt: '',
                    regDtm: '',
                    chgDtm: '',
                    files: ''
                }
            }

        },
        created() {
            if(location.href.indexOf('notice') > -1){
              this.title = "공지사항";
              this.category = "notice";
            }

            if(location.href.indexOf('faq') > -1){
              this.title = "FAQ";
              this.category = "faq";
            }

            this.form.category = this.title;
            this.form.comp_cd = this.$store.state.loginInfo.compCd
            this.form.writer = this.$store.state.loginInfo.userName
            this.form.writer_id = this.$store.state.loginInfo.loginId
            this.authority = this.$store.state.loginInfo.authorities[0].roleCd;

            if(this.contentId == undefined){
                //작성
                this.title = this.title + " 작성";
                this.updateMode = false;
            }else{
                //수정
                this.title = this.title + " 수정";
                this.updateMode = true;
                this.getContentItems(this.contentId);
            }
        },
        mounted() {

        },
        methods: {
            savePost(){ 
                // 유효성검사
                if(this.form.subject === ""){
                    setTimeout(()=> {
                    this.$swal({type: 'warning', text: '제목을 입력해주시기 바랍니다.'})
                        ,10});
                    this.$refs.subject.focus();
                    return false;
                }

                if(this.form.content === ""){
                    setTimeout(()=> {
                    this.$swal({type: 'warning', text: '내용을 입력해주시기 바랍니다.'})
                        ,10});
                    this.$refs.editor.quill.focus();
                    return false;
                }
                
                //저장
                let formData = new FormData();
                formData.append('formData', new Blob([JSON.stringify(this.form)],{
                    type: "application/json"
                }));

                for( let i = 0; i < this.$refs.addFile.files.length; i++ ){
                    let file = this.$refs.addFile.files[i];
                    formData.append('files', file);
                }

                this.$http.post(`/api/board/post`, formData, {
                    headers: {'Content-Type' : 'multipart/form-data'}
                }).then(() => {
                    this.$swal({ type: 'info', text: '저장되었습니다.'
                    }).then(() => {
                        this.$router.push({path: `/ijdm/board/` + this.category});
                    });
                }).catch((e) => {
                    console.error(e);
                });
            },
            getContentItems(contentId) {
                this.$http.post(`/api/board/detail`, { id: contentId })
                    .then(response => {
                        this.form.id = response.data.id;
                        this.form.subject = response.data.subject;
                        this.form.content = response.data.content;
                        this.form.viewCnt = response.data.viewCnt;
                        this.form.regDtm = response.data.regDtm;
                        this.form.chgDtm = response.data.chgDtm;
                        this.form.files = response.data.files;
                    });
            },
            proceedFileUpload() {
                let files = this.$refs.addFile.files

                // Ok to proceed
                if (files.length > 0) {
                    let form = new FormData()

                    _.forEach(files, (file, i) => {
                        form.append(`files`, file)
                    })

                    this.$store.commit('loading')
                    this.$http.post(`/api/board/addFiles/${this.form.comp_cd}/${this.docMngNo}`, form, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(response => {
                        this.$swal({
                            type: 'success',
                            text: '파일이 업로드 되었습니다.'
                        }).then(() => {
                            this.a_files = this.a_files.concat(response.data)
                        })
                        return response
                    }).catch(response => {
                        this.$swal({
                            type: 'error',
                            text: '파일업로드에 실패하였습니다.'
                        })
                        return response
                    }).finally(() => {
                        this.$store.commit('finish')
                    })
                }
            },

            clickAddFileBtn(){
                $('#files').trigger( "click" );
            },

            selectFiles(){
                this.fileList = [];
                let files = document.getElementById('files').files;
                for(let i=0; i<files.length; i++){
                    this.fileList.push({name:files[i].name, listCount:i});
                }

                for( let i = 0; i < this.$refs.addFile.files.length; i++ ){
                    let file = this.$refs.addFile.files[i];
                }
            },

            deleteFile: function(index){
                this.fileList.splice(index, 1);
            },
            downloadFile(url) {
                this.$store.commit('loading');
                this.$http
                    .get(url, { responseType: 'blob' })
                    .then((response) => {
                        const downloadedfile = new Blob([response.data], { type: 'blob' });
                        let url;

                        const contentDisposition = response.headers['content-disposition'];
                        let fileName = 'unknown';
                        if (contentDisposition) {
                            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                            if (fileNameMatch.length === 2)
                                fileName = decodeURI(fileNameMatch[1]);
                        }

                        if (window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(downloadedfile, fileName);
                        } else {
                            url = window.URL.createObjectURL(downloadedfile);

                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                        }

                        this.$store.commit('finish');
                    });
            },
            cancel(){
                if(this.subject != "" || this.context != ""){
                    this.$swal({
                        html: '작성중인 내용을 저장하지 않고 취소하시겠습니까?',
                        showCloseButton: true,
                        showCancelButton: true,
                        confirmButtonText: '예',
                        cancelButtonText: '아니요',
                        focusConfirm: false,
                    }).then((result) => {
                        if(result.value){
                            this.$router.go(-1);
                        }
                    });
                }else{
                    this.$router.go(-1);
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "public/css/bulma";

    .inner-box{
        height: 100%;
        width:95%;
        left: 0;
        right: 0;
        margin: 0 auto 30px;
    }

    @media (min-width: 1000px) {
        .inner-box{
            width:1000px;
        }
    }

    .title{
        font-size:40px;
        text-align:center;
        margin-top:50px;
    }

    .title-s{
        font-size:15px;
        color:#666;
        text-align:center;
        padding:0 0 30px 0;
    }

    .inner-box h1{
        font-size:20px;
        padding:50px 0 10px 0;
        font-weight: bold;
    }

    .inner-box ul{
        top: 30px;
        width: 100%;
        height: 60px;
        border:1px solid #d5d5d5;
    }

    .inner-box ul li{
        float: left;
        width: 33.3%;
        color: #888;
        text-align: center;
        display: block;
        line-height: 58px;
        font-weight: 700;
        border-right:1px solid #d5d5d5
    }

    .inner-box ul li:last-child{
        border-right:0;
    }

    .inner-box .on{
        background-color: #023e7c;
        color:#fff;
    }

    table.visit-info-table{
        border-top: 1px solid #aaaaaa;
        width: 100%;
    }

    table.visit-info-table td {
        border-bottom: 1px solid #ddd;
        color: #999;
        padding: 15px 0 15px 10px;
        font-size: 14px;
        vertical-align: middle;
    }

    table.visit-info-table th {
        border-bottom: 1px solid #ddd;
        color: #666;
        padding: 15px 10px 15px 10px;
        font-size: 14px;
        vertical-align: middle;
        background: #f9f9f9;
        line-height: normal;
        text-align: center;
    }

    table.visit-info-table td input{
        width: 35%;
    }

    table.visit-info-table td p input{
        width: 100%;
    }

    table.visit-info-table td select{
        padding:10px 40px 10px 15px;
    }

    table.visit-info-table td.tit{
        background: #f9f9f9;
        padding-left: 30px;
        color: #666;
        line-height: normal;
    }

    table.visit-info-table td.tit-c{
        background: #f9f9f9;
        color: #666;
        line-height: normal;
        text-align: center;
    }

    table.visit-info-table td.list-c{
        text-align: center;
    }

    table.visit-info-table td button{
        margin-left:10px;
    }

    .inner-box button{
        margin:15px 5px;
        padding:10px;
        border:1px solid #d5d5d5;
        text-align:center;
    }

    .inner-box .btn{
        text-align:center;
    }

    .inner-box button:first-child{
        background-color: #023e7c;
        color:#fff;
    }

    .inner-box button:last-child{
        background-color: #b3b3b3;
        color:#fff;
    }

    .ql-toolbar.ql-snow{

    }

    .inner-box .clickAddFileBtn{
        padding: 5px;
        margin:0px;
    }

    .fileList{
      cursor: pointer;
      margin-right: 15px;
    }
    .deleteBtn{
      color: #d43f3a;
      margin-left: 10px;
      cursor: pointer;
    }
</style>